import { Component } from '@angular/core';

@Component({
  selector: 'unauthorized',
  standalone: false,
  templateUrl: './unauthorized.component.html',
  host: {
    class: 'angular-component-wrapper',
  },
})
export class UnauthorizedComponent {}
